import { apiRequest } from '../../shared/api';

export interface IntegrationMessagePayloadItem {
  id: string;
  messageId: string;
  payloadType: 'REQUEST' | 'RESPONSE' | 'ORIGINAL' | 'TRANSFORMED';
  objectStorageRef?: string | null;
  payloadHash?: string | null;
  compression?: string | null;
  encryptionKeyRef?: string | null;
  createdAt: string;
  message?: {
    id: string;
    messageType: string;
    direction: string;
    status: string;
    sourceSystem?: string | null;
    targetSystem?: string | null;
  };
}

export interface RecordPayloadInput {
  payloadType: string;
  objectStorageRef?: string;
  payloadHash?: string;
  rawPayloadContent?: string;
  compression?: string;
  encryptionKeyRef?: string;
}

export const integrationPayloadService = {
  async getPayloads(limit: number = 50): Promise<IntegrationMessagePayloadItem[]> {
    return await apiRequest<IntegrationMessagePayloadItem[]>(`/v1/integrations/payloads?limit=${limit}`);
  },

  async getPayloadsByMessageId(messageId: string, type?: string): Promise<IntegrationMessagePayloadItem[]> {
    const query = type ? `?type=${type}` : '';
    return await apiRequest<IntegrationMessagePayloadItem[]>(`/v1/integrations/messages/${messageId}/payloads${query}`);
  },

  async recordPayload(messageId: string, payload: RecordPayloadInput): Promise<IntegrationMessagePayloadItem> {
    return await apiRequest<IntegrationMessagePayloadItem>(`/v1/integrations/messages/${messageId}/payloads`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }
};
